import Box from '@mui/material/Box';
import type { SxProps, Theme } from '@mui/material/styles';
import type { FC } from 'react';
import { NAVY, STATUS_GOOD, STATUS_WARN } from 'styles/tokens';
import { type CostTier, getCostTier } from 'utils/aiModels';

const TIER_COLOR: Record<CostTier, string> = {
  $: STATUS_GOOD,
  $$: NAVY,
  $$$: STATUS_WARN,
  $$$$: '#E7233B',
};

const TIER_TITLE: Record<CostTier, string> = {
  $: 'Barato',
  $$: 'Medio',
  $$$: 'Caro',
  $$$$: 'Muy caro',
};

interface CostTierBadgeProps {
  model: string;
  sx?: SxProps<Theme>;
}

/**
 * Affordability badge ($ … $$$$) for an AI model, color-coded cheap→expensive.
 * Renders nothing for proxies/unknown models. Shared by model pickers (playground, BU config).
 */
const CostTierBadge: FC<CostTierBadgeProps> = ({ model, sx }) => {
  const tier = getCostTier(model);
  if (!tier) {
    return null;
  }
  return (
    <Box
      component="span"
      title={TIER_TITLE[tier]}
      sx={{
        color: TIER_COLOR[tier],
        fontWeight: 700,
        letterSpacing: '0.5px',
        flexShrink: 0,
        fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
        ...sx,
      }}
    >
      {tier}
    </Box>
  );
};

export default CostTierBadge;
